module.exports = __webpack_public_path__ + "./images/afa9123079261cea368fcaa6bdc77205.webp";